import { useLang } from "../i18n/LanguageContext";
import { FadeUp, MaskedLine } from "../components/motion";
import { SEO } from "../components/SEO";
import RendezvousFormulaire from "../components/RendezvousFormulaire";

export default function Rendezvous() {
  const { t, ts } = useLang();
  return (
    <div data-testid="rendezvous-page" className="pt-32 pb-28 spotlight min-h-screen">
      <SEO title={`${ts("rdv.title_1")} ${ts("rdv.title_2")} — Mr Trophée`} description={ts("rdv.sub")} path="/rendez-vous" />
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <FadeUp>
          <p className="text-gold tracking-[0.3em] uppercase text-xs mb-4">{t("rdv.kicker")}</p>
          <h1 className="font-serif text-5xl md:text-6xl leading-tight mb-6">
            <MaskedLine key={ts("rdv.title_1")} delay={0.15}>{t("rdv.title_1")}</MaskedLine>{" "}
            <MaskedLine key={ts("rdv.title_2")} delay={0.35} className="italic text-gold">{t("rdv.title_2")}</MaskedLine>
          </h1>
          <p className="text-ivory/60 max-w-xl mb-10">{t("rdv.sub")}</p>
        </FadeUp>
        <RendezvousFormulaire />
      </div>
    </div>
  );
}
